var _path, _path2, _path3, _path4, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery5Full(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 148,
    viewBox: "0 0 142 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3803 68.3903C11.448 58.9369 17.2359 41.0211 32.3079 28.3741C47.3799 15.7272 66.0287 13.1383 73.961 22.5917L125.216 83.6752C133.148 93.1286 127.361 111.044 112.289 123.691C97.2165 136.338 78.5678 138.927 70.6355 129.474L19.3803 68.3903Z",
    fill: "#245F9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4136 67.7715C8.00768 57.7538 14.0547 38.8408 29.92 25.5283C45.7853 12.2157 65.461 9.54473 73.8669 19.5625L122.213 77.1796C130.619 87.1974 124.572 106.11 108.707 119.423C92.8417 132.735 73.166 135.406 64.7601 125.389L16.4136 67.7715Z",
    fill: "#01D787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2914 67.2207L77.0575 73.2906C75.1661 74.8777 72.3036 74.2378 71.323 72.0086L65.3198 58.3643C64.2682 55.9742 60.6552 56.8757 60.7909 59.4946L62.7986 98.2537C62.9576 101.324 66.5596 102.851 68.9372 100.856L76.171 94.7856C78.0625 93.1985 80.925 93.8385 81.9056 96.0676L87.9088 109.712C88.9604 112.102 92.5734 111.201 92.4377 108.582L90.4299 69.8224C90.2708 66.7524 86.6689 65.2258 84.2914 67.2207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2904 67.2236L78.6338 71.97C80.601 81.3017 77.4284 91.4544 69.5241 98.0869C68.0142 99.3539 66.407 100.427 64.7341 101.311C65.9992 101.985 67.6472 101.94 68.9363 100.858L76.1701 94.7885C78.0616 93.2014 80.924 93.8414 81.9047 96.0705L87.9078 109.715C88.9594 112.105 92.5724 111.203 92.4367 108.585L90.4291 69.8251C90.2698 66.7553 86.6679 65.2287 84.2904 67.2236Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9535,
    cy: 38.6784,
    rx: 33.75,
    ry: 17.1659,
    transform: "rotate(-40 40.9535 38.6784)",
    fill: "#245F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6953,
    cy: 31.2211,
    rx: 18.75,
    ry: 9.28566,
    transform: "rotate(-40 34.6953 31.2211)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery5Full);
export default __webpack_public_path__ + "static/media/battery-5-full.3aaa31429ee60bf08f0cfc0f57a22b89.svg";
export { ForwardRef as ReactComponent };